import React from "react";
import "../App.css";
import cross from '../pics/svg/cross.svg'
import Flags from './flags'

function Countries({ countries, id }) {

    function checkList() {
        let lastItem = countries[countries.length - 1];
        if (lastItem[1] === ":") {
            lastItem = lastItem.replace("e:+", "")
            countries[countries.length - 1] = lastItem + " more!"
        }
    }
    
    function hideCountries() {
        document.querySelector(`.${id} .banner`).style.display = "flex"
        document.querySelector(`.${id} .countries-wrapper`).style.opacity = 0
        document.querySelector(`.${id} .countries-wrapper`).style.pointerEvents = 'none'
    }

    checkList();

    return (
        <div className="countries-container">
            <img className="cross" onClick={hideCountries} src={cross} alt="X"/>
            <h5>Available on Netflix in these countries:</h5>
            <ul>
                {countries.map((country) => (
                    <li key={country}>{`${!(country[country.length-1] === "!") ? Flags[country] : "Plus "} ${country}`}</li>
                ))}
            </ul>
            <a href="https://www.techradar.com/vpn/best-vpn" target="_blank" rel="noopener noreferrer">Get a VPN</a>
        </div>
    );
}

export default Countries;
